import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';

import { makeStyles } from 'utils';
import classNames from './Refiner.module.css';
import { fieldShape, selectorShape } from './Refiner.props';

const blankValue = 'Y2M5NzAzNWEtNGRjYy00Nzc2LTk3ODYtZGVmZjZlOTFjMjE4';
const styles = makeStyles(classNames);
const noOp = v => v;

function RefinerSelectField({
    idBase,
    readOnly,
    selectedField,
    selector,
    uniqueFieldValues,
    value,
    onChange
}) {
    const { type, format = noOp, allowEmpty } = selectedField;
    const { error } = selector;
    const multiple = type === 'list';

    return (
        <FormControl error={!!(error)} className={styles('row__form-control')}>
            <InputLabel id={idBase + '_value-label'} htmlFor={idBase + '_value'}>Value</InputLabel>
            <Select
                id={idBase + '_value'}
                className={styles('row__input')}
                disabled={readOnly}
                multiple={multiple}
                value={value || (multiple ? [] : '')}
                onChange={onChange}
            >
                {uniqueFieldValues.map((val) => (
                    <MenuItem key={val} value={val}>
                        {format(val)}
                    </MenuItem>
                ))}
                {uniqueFieldValues.hasEmptyValues && allowEmpty && (
                    <MenuItem key={blankValue} value={blankValue} className={styles('row__menu-item--empty')}>Not Set</MenuItem>
                )}
            </Select>
            {error && (<FormHelperText>{error}</FormHelperText>)}
        </FormControl>
    );
}

RefinerSelectField.propTypes = {
    idBase: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    selectedField: PropTypes.shape(fieldShape).isRequired,
    selector: PropTypes.shape(selectorShape).isRequired,
    uniqueFieldValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    onChange: PropTypes.func.isRequired,
};

export default RefinerSelectField